// extracted by mini-css-extract-plugin
export var component = "CustomInfiniteHits-module--component--cc106";
export var fadePop = "CustomInfiniteHits-module--fade-pop--244fd";
export var growHeightIn = "CustomInfiniteHits-module--grow-height-in--98906";